import { Text } from 'foundations-components/components/Text';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getContentAssistantSettingsPageURL } from '../../utils/urls';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const AiSearchCta = () => {
  return /*#__PURE__*/_jsx(Text, {
    as: "p",
    marginBlockStart: "100",
    marginBlockEnd: "600",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'reports.globalSearch.aiRecommendationsCTA_jsx',
      options: {
        href: getContentAssistantSettingsPageURL()
      },
      elements: {
        Link
      }
    })
  });
};
export default AiSearchCta;